import { RouterProvider } from 'react-router-dom';

import { router } from '../routing/router';

export const App = () => <RouterProvider router={router} />;
